import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const { L } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await fetch(`${API}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-[calc(100vh-104px)] items-center justify-center px-6 py-20" data-testid="forgot-password-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }} className="w-full max-w-md">
        <p className="mono-tech mb-4 text-[#A8853B]">{L({ en: "Client Area", it: "Area Clienti" })}</p>
        <h2 className="font-display text-3xl text-[#0E3B33] sm:text-4xl">{L({ en: "Reset your password.", it: "Reimposta la password." })}</h2>
        {!sent ? (
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="forgot-password-form">
            <p className="text-sm leading-relaxed text-[#4A5248]">
              {L({
                en: "Enter the email of your client account — we'll send you a reset link valid for one hour.",
                it: "Inserisci l'email del tuo account cliente — ti invieremo un link di ripristino valido un'ora.",
              })}
            </p>
            <input required type="email" data-testid="forgot-email-input" className="forge-field" placeholder="you@yourbrand.com" value={email} onChange={(e) => setEmail(e.target.value)} />
            <button type="submit" disabled={busy} data-testid="forgot-submit-btn" className="ember-btn w-full justify-center disabled:opacity-60">
              {busy ? L({ en: "Sending…", it: "Invio…" }) : L({ en: "Send reset link", it: "Invia link di ripristino" })}
            </button>
          </form>
        ) : (
          <div className="mt-8 rounded-md border border-[#C9A84C]/40 bg-[#C9A84C]/10 p-5 text-sm leading-relaxed text-[#4A5248]" data-testid="forgot-success">
            {L({
              en: "If that email belongs to an account, a reset link is on its way. Check your inbox — and the spam folder, just in case.",
              it: "Se l'email corrisponde a un account, il link di ripristino è in arrivo. Controlla la posta in arrivo — ed eventualmente lo spam.",
            })}
          </div>
        )}
        <p className="mt-6 text-center text-xs text-[#8A8F82]">
          <Link to="/login" data-testid="forgot-back-login" className="font-medium text-[#A8853B] hover:text-[#0E3B33]">
            {L({ en: "Back to sign in", it: "Torna all'accesso" })}
          </Link>
        </p>
      </motion.div>
    </div>
  );
}
